import $ from 'jquery';

export default class UserList {
  init () {
    const preloadImage = elm => {
      const image = $(elm);
      image.attr('src', image.data('src'));
    };

    const config = {
      root: document.querySelector('.user-list'),
      rootMargin: '0px',
      threshold: 0,
    };

    let observer = new IntersectionObserver((entries, self) => {
      // iterate over each entry
      entries.forEach(entry => {
        // process just the images that are intersecting.
        // isIntersecting is a property exposed by the interface
        if (entry.isIntersecting) {
          // custom function that copies the path to the img
          // from data-src to src
          preloadImage(entry.target);
          // the image is now in place, stop watching
          self.unobserve(entry.target);
        }
      });
    }, config);

    $('.user-list').find('img').each((i, elm) => {
      observer.observe(elm);
    });

    $(document).on('click', '.user-list-card .js-user-list-card-expand', event => {
      const self = $(event.currentTarget);
      self
        .closest('.user-list-card')
        .toggleClass('is-open')
        .find('.js-user-list-card-details')
        .slideToggle();
    });

    // User list tab
    $('.user-list .user-list__link').on('show.bs.tab', event => {
      const self = $(event.target);

      self.parents('.user-list').find('img').each((i, elm) => {
        observer.observe(elm);
      });
    });
  }
}
